export default __webpack_public_path__ + "static/media/encour_icon.476f5165.svg";